export default __webpack_public_path__ + "static/media/BitterPro-Regular.befb0b6f.ttf";